module.exports = {
  title: 'Tracking Configuration',
  titleStringId: 'trackingConfiguration',
  id: 'open_drawer',
  type: 'tracking-configuration',
};
